export default __webpack_public_path__ + "static/img-project-1-ed356358902909ef9252e2a960b9f743.png";